<div class="user-select">
  <div class="user-content" v-if="!$slots.default" :class="{'is-error':isError,'disabled':disabled}">
    <div class="user-list"  @click="showModal">
      <span v-if="!tempUsers.length" >请选择</span>
      <template v-else>
        <a-tag
          :disabled="disabled"
          v-for="user in tempUsers"
          :key="user.id"
          :closable="!disabled"
          color="blue"
          @close.prevent="deleteSelectedUser(user.id)"
        >
        <span v-if="user.name.length<10">
          {{ user.name }}
        </span>
          <a-tooltip v-else :title="user.name" class="append-to-body" >
            {{user.name.slice(0,9)+'...'}}
          </a-tooltip>
        </a-tag>
      </template>
    </div>
    <div
      class="add-icon"
      v-if="tempUsers.length < maxCount"
      type="link"
      @click="showModal"
    >
      <img src="../../assets/images/icon_add.png" />
    </div>
  </div>

  <span v-if="$slots.default" @click="showModal">
    <slot></slot>
  </span>
  <!--  <template v-else>-->
  <!--    <a-button-->
  <!--      v-if="maxCount === 0 || selectedUsers.length < maxCount"-->
  <!--      style="padding: 0"-->
  <!--      type="link"-->
  <!--      @click="showModal"-->
  <!--    >-->
  <!--      <ant-icon type="PlusCircleOutlined"></ant-icon>-->
  <!--      <span>添加</span>-->
  <!--    </a-button>-->
  <!--  </template>-->

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    class="user-select-modal user-mod"
    width="520px"
    :zIndex="1002"
    @cancel="cancelFn"
    @ok="ok"
  >
    <template #title>
      <span>选择员工</span>
      <small v-if="maxCount && maxCount !== Infinity">本次操作最多可选 {{ maxCount }} 个员工</small>
    </template>
    <div class="user-select-modal__bd">
      <div class="user-select__left">
        <div class="user-select__left__hd">
          <user-search-select
            v-model:value="userSearchId"
            class="w100"
            placeholder="输入员工姓名关键字"
            :activated-status="activatedStatus"
            :on-job="onJob"
            :status="status"
            :userState = "userStatus"
            @select="onUserSearchSelect"
          ></user-search-select>
        </div>
        <div class="user-select__left__bd">
          <vxe-table
          v-if="visible"
          :show-header="false"
          border="none"
          ref="xTree"
          :row-config="{keyField: 'id'}"
          :column-config="{resizable: true}"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasEmployee', loadMethod: loadDepartment}"
          :data="treeData">
          <vxe-column field="name" title="公司员工" width="260" :tree-node="true">
            <template #default="{ row }">
              <span :class="row.isLeaf&&!row.isDepartment?'is-leaf':''" @click="clickRow(row)">
                <!-- <template v-if="row.children && row.children.length>0 && row.hasChildren">
                  <i class="tree-node-icon fa" :class="$refs.xTree.isTreeExpandByRow(row) ? 'fa-folder-open-o' : 'fa-folder-o'"></i>
                </template> -->
                <template v-if="row.isLeaf">
                  <user-outlined  v-if="!row.isDepartment"/>
                  <fork-outlined v-else/>
                </template>
                <template v-else>
                  <fork-outlined />
                </template>
                <span style="margin-left:6px;">{{ row.name }}</span>
              </span>
            </template>
          </vxe-column>
        </vxe-table>
        </div>
      </div>
      <div class="user-select__right">
        <div class="user-select__right__hd">
          <span class="text-grey">已选择的成员 （ {{ tempUsers.length }} 个）</span>
        </div>
        <div class="user-select__right__bd">
          <div v-for="item in tempUsers" :key="item.id" class="selected-user">
            <div class="selected-user__icon">
              <ant-icon type="UserOutlined"></ant-icon>
            </div>
            <span>{{ item.name }}</span>
            <div class="selected-user__delete" @click="deleteTempUser(item.id)">
              <ant-icon type="CloseCircleOutlined"></ant-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</div>
